import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from '@easymoving/ui';
import { COMPACT_SELECT, destinationDotOptions, statusDotOptions } from './themedOptions';

interface BaseProps {
  value: string;
  onValueChange: (value: string) => void;
  ariaLabel?: string;
  /** Compact, content-width trigger (for inline quick-edit in rows). */
  compact?: boolean;
  /** Extra leading options without a dot (e.g. "All", "No change"). */
  lead?: { value: string; label: ReactNode }[];
}

/** Themed destination dropdown (tone-coloured dot per option). */
export function DestinationSelect({ value, onValueChange, ariaLabel, compact, lead = [] }: BaseProps) {
  const { t } = useTranslation();
  return (
    <Select
      ariaLabel={ariaLabel ?? t('item.destination')}
      value={value}
      onValueChange={onValueChange}
      options={[...lead, ...destinationDotOptions(t)]}
      className={compact ? COMPACT_SELECT : undefined}
    />
  );
}

/** Themed progress-status dropdown (tone-coloured dot per option). */
export function StatusSelect({ value, onValueChange, ariaLabel, compact, lead = [] }: BaseProps) {
  const { t } = useTranslation();
  return (
    <Select
      ariaLabel={ariaLabel ?? t('item.status')}
      value={value}
      onValueChange={onValueChange}
      options={[...lead, ...statusDotOptions(t)]}
      className={compact ? COMPACT_SELECT : undefined}
    />
  );
}
